module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/import-bf44ae2e1ea1af7eef97f56717a062e2.svg&quot;;"